export const COMPETITION_ID = '-OIAeuYwVsC94nRAxMmk';
